import { NotificationList } from 'components/common/NotificationList'
import { put, takeLatest } from 'redux-saga/effects'
import { makeGetRequest } from 'utils/api'
import { formatResponse, formatErrorMessage } from 'utils/formatting'
import * as ACT from './actions'
import { PUSH_NOTIFICATION } from 'actions/actionTypes'

function* fetchBidFollowUp() {
  try {
    const url = '/v1/reports/bidAndFollowUpLists'
    const reportsBidFollowUp = yield makeGetRequest(url)
    yield put({
      type: ACT.BID_FOLLOW_UP_FETCH_SUCCESS,
      payload: {
        reportsBidFollowUp: reportsBidFollowUp.content
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue fetching Bid and Follow Up Reports',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

const listsSagas = [takeLatest(ACT.BID_FOLLOW_UP_FETCH_REQUESTED, fetchBidFollowUp)]

export default listsSagas
